module.exports = __webpack_public_path__ + "media/images/games/vortex/vortex-694acb431fa1846fb3b2a2af55bcbfab.png";